/*
 * Plausible storefront events fired from the theme.
 * The customized theme doesn't reliably emit Shopify's standard
 * `search_submitted` / `product_added_to_cart` Web Pixel events, so the
 * Plausible Custom Pixel never received them. We fire them here instead:
 *   - Search:      on any storefront search-form submit
 *   - Add to Cart: by intercepting the /cart/add request (catches EVERY
 *                  add path — product page, quick-add, cards, drawer, etc.)
 */
(function () {
  // --- Search ---------------------------------------------------------------
  document.addEventListener(
    'submit',
    function (e) {
      try {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        var action = form.getAttribute('action') || '';
        var isSearch =
          form.getAttribute('role') === 'search' ||
          form.classList.contains('search') ||
          action.indexOf('/search') > -1;
        if (!isSearch) return;
        var input = form.querySelector('input[name="q"]');
        var query = input && input.value ? input.value.trim() : '';
        if (!query) return;
        if (window.plausible) {
          window.plausible('Search', { props: { searchQuery: query } });
        }
      } catch (err) {}
    },
    true
  );

  // --- Add to Cart (intercept /cart/add) ------------------------------------
  if (window.fetch && !window.__plausibleCartHooked) {
    window.__plausibleCartHooked = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) {}
      var promise = origFetch.apply(this, args);

      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        promise
          .then(function (res) {
            try {
              return res.clone().json();
            } catch (e) {
              return null;
            }
          })
          .then(function (data) {
            if (!data || !window.plausible) return;
            var items = data.items ? data.items : [data];
            var currency =
              (window.Shopify && Shopify.currency && Shopify.currency.active) || 'RSD';
            items.forEach(function (item) {
              if (!item || item.status || !item.id) return; // skip errors / non-items
              var amount =
                (item.final_line_price != null
                  ? item.final_line_price
                  : (item.final_price || 0) * (item.quantity || 1)) / 100;
              window.plausible('Add to Cart', {
                revenue: { amount: amount, currency: currency },
                props: {
                  productTitle: item.product_title || '',
                  quantity: item.quantity || 1
                }
              });
            });
          })
          .catch(function () {});
      }
      return promise;
    };
  }
})();
